export default "__VITE_ASSET__C0lH5W50__"